import React from "react";
import { BlogCompBanner } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { renderRichText } from '@/lib/richText';

interface BlogCompBannerProps {
  blok?: BlogCompBanner & SbBlokData;
}

const BlogCompBannerComponent: React.FC<BlogCompBannerProps> = ({ blok }) => {
  if (!blok) return null;

  const { banner_type, body, title } = blok;

  switch (banner_type) {
    case "blue_bg":
      return (
        <div {...storyblokEditable(blok)} className="brand-section">
          <div className="container row mx-auto align-items-center py-4 py-md-5">
            <div className="col-24 lead text-center">
              {body && (
                <div
                  dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
                />
              )}
            </div>
          </div>
        </div>
      );

    case "red_bg":
      return (
        <div {...storyblokEditable(blok)} className="blog-feature-section">
          <div className="container">
            <div className="full-width text-center">
              {body && (
                <span
                  className="mb-o"
                  dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
                />
              )}
            </div>
          </div>
        </div>
      );

    case "blockquote":
      return (
        <div {...storyblokEditable(blok)} className="blog-feature-section">
          <div className="container">
            <div className="full-width text-center">
              {body && (
                <span
                  className="mb-o"
                  dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
                />
              )}
            </div>
          </div>
        </div>
      );

    case "bonus":
      return (
        <div className="container" {...storyblokEditable(blok)}>
          <div className="py-4">
            <div className="two-thirds-centered">
        <div className="blog-panel-w-icon">
          <svg width="70" height="70" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M51.755 48.623L6.168 68.46C3.197 69.642.244 66.714 1.4 63.733l19.922-46.305" fill="#FFB636"></path>
            <path d="M1.4 63.733l1.584-3.68c.135-.207.27-.414.407-.62 7.874-11.997 15.864-23.92 24.127-35.653l9.265 9.497C29.793 38.076 7.094 61.532 2.34 67.754c-1.035-.952-1.538-2.478-.94-4.02z" fill="#FFD469"></path>
            <path d="M41.615 27.95c8.456 8.457 13.082 17.542 10.33 20.293-2.75 2.751-11.836-1.874-20.293-10.33-8.456-8.457-13.081-17.543-10.33-20.294 2.75-2.751 11.836 1.874 20.293 10.33z" fill="#A06C33"></path>
            <path d="M21.274 44.785a1.488 1.488 0 11-2.977 0 1.488 1.488 0 012.977 0z" fill="#F7F9AA"></path>
            <path d="M68.63 29.143a2.136 2.136 0 11-4.27 0 2.136 2.136 0 014.27 0zm-14.262 28.44a2.136 2.136 0 100 4.272 2.136 2.136 0 000-4.272z" fill="#FFB636"></path>
            <path d="M48.665 10.872c-.183 1.24-.984 2.334-2.197 3.003-.838.463-1.823.703-2.845.703-.325 0-.65-.024-.973-.072-.723-.107-1.447.002-1.985.3-.242.132-.656.424-.724.88-.067.455.246.854.438 1.051.418.429 1.056.736 1.757.85l.058.006c2.955.437 5.066 2.778 4.706 5.22-.184 1.239-.984 2.333-2.198 3.003-.837.462-1.822.702-2.844.702-.326 0-.651-.024-.973-.072-.723-.107-1.447.002-1.985.3-.242.133-.657.424-.724.88-.108.731.79 1.697 2.252 1.912a1.456 1.456 0 11-.426 2.88c-2.956-.436-5.067-2.777-4.706-5.218.183-1.24.984-2.334 2.197-3.004 1.101-.607 2.457-.831 3.818-.63.723.107 1.446-.002 1.985-.3.241-.133.656-.424.724-.88.106-.72-.763-1.664-2.183-1.9-.023-.002-.047-.004-.07-.008-1.36-.2-2.594-.807-3.472-1.708-.968-.991-1.417-2.27-1.234-3.51.183-1.24.984-2.335 2.197-3.004 1.101-.608 2.457-.832 3.818-.63.723.106 1.447-.003 1.985-.3.242-.133.656-.424.724-.88.067-.456-.246-.855-.438-1.052-.43-.44-1.09-.754-1.814-.86a1.456 1.456 0 11.426-2.881c1.36.201 2.593.808 3.472 1.708.968.992 1.417 2.272 1.234 3.511z" fill="#BEA4FF"></path>
            <path d="M11.174 21.832a2.42 2.42 0 11-4.84 0 2.42 2.42 0 014.84 0zm43.264-2.796a2.796 2.796 0 100 5.592 2.796 2.796 0 000-5.592zm-24.971 35.09a2.796 2.796 0 100 5.593 2.796 2.796 0 000-5.593zm37.092-12.803a1.669 1.669 0 00-.717-2.248c-.326-.169-.716-.392-1.167-.651-3.964-2.274-12.212-7.006-21.923.835a1.669 1.669 0 102.096 2.597c7.935-6.406 14.34-2.733 18.166-.537.465.267.905.519 1.297.72a1.668 1.668 0 002.248-.716z" fill="#FF6E83"></path>
            <path d="M59.45 8.583a1.488 1.488 0 11-2.976 0 1.488 1.488 0 012.976 0zM6.333 1.626a1.488 1.488 0 100 2.976 1.488 1.488 0 000-2.976zM29.67 21.048c.168-.33.375-.706.595-1.104 1.115-2.02 2.642-4.785 2.734-8.006.11-3.87-1.906-7.383-5.99-10.442a1.604 1.604 0 10-1.923 2.567c3.247 2.432 4.786 4.978 4.706 7.784-.07 2.443-1.326 4.719-2.335 6.547-.232.422-.452.82-.644 1.196a1.604 1.604 0 102.857 1.458z" fill="#59CAFC"></path>
          </svg>
          <div>
            {title && <h3 className="text-secondary">{title}</h3>}
            {body && (
              <div
                dangerouslySetInnerHTML={{
                  __html: renderRichText(body)
                    .replace(/<a /g, '<a class="text-decoration-underline text-secondary" target="_blank" ')
                }}
              />
            )}
          </div>
        </div>
            </div>
          </div>
        </div>
      );


    default:
      return (
        <div {...storyblokEditable(blok)} className="blog-feature-section">
          <div className="container">
            <div className="full-width text-center">
              {body && (
                <span
                  className="mb-o"
                  dangerouslySetInnerHTML={{ __html: renderRichText(body) }}
                />
              )}
            </div>
          </div>
        </div>
      );
  }
};

export default BlogCompBannerComponent;